import React, { useEffect, useRef } from 'react'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

import iconRanking from '../../img/svg/ranking.svg'
import iconReward from '../../img/svg/gift.svg'
import iconRoyalty from '../../img/svg/NFT.svg'

gsap.registerPlugin(ScrollTrigger)

const FounderFeatures = () => {
  const sectionRef = useRef(null)

  useEffect(() => {
    const features = sectionRef.current.querySelectorAll('.feature-box')
    gsap.set(features, { opacity: 0, y: 40 })

    ScrollTrigger.create({
      trigger: sectionRef.current,
      start: 'top 85%',
      once: true,
      onEnter: () => {
        gsap.to(features, {
          opacity: 1,
          y: 0,
          duration: 0.6,
          stagger: 0.2,
          ease: 'power3.out'
        })
      }
    })

    return () => ScrollTrigger.getAll().forEach(t => t.kill())
  }, [])

  return (
    <section className="founder-features-section" ref={sectionRef}>
      <div className="alignment-wrapper">
        <h2>Key Features for Founders</h2>
        <div className="founder-features-grid">
          <div className="feature-box">
            <img src={iconRanking} alt="Backer Rankings" className="icon" />
            <h3>Backer Rankings</h3>
            <p>Founders receive a complete ranking of Backers, including scores, to track engagement.</p>
          </div>
          <div className="feature-box">
            <img src={iconReward} alt="Customizable Rewards" className="icon" />
            <h3>Customizable Rewards</h3>
            <p>Founders can tailor rewards and promotions to incentivize Backers.</p>
          </div>
          <div className="feature-box">
            <img src={iconRoyalty} alt="Royalty Tracking" className="icon" />
            <h3>Royalty Tracking</h3>
            <p>
              RWA Tickets use blockchain-based <strong>royalty tracking technology</strong> to ensure accurate and transparent royalty distribution.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FounderFeatures
